import React from 'react';
import { SimulateButtonWrapper } from './simulateButtons.styled';
import { ButtonSmall } from '../../../../app/common/sharedComponents/buttons/ButtonSmall';
import { ISimulateButtons } from '../../../../app/@types/simulateButtons';

export function SimulateButtons ({
  simulateButtonList,
  handleSimulateButtonClick,
}: ISimulateButtons) {
  return (
    <>
      <SimulateButtonWrapper>
        {simulateButtonList.length > 0 &&
          simulateButtonList.map((button, index) => {
            return (
              <ButtonSmall
                key={button.title}
                title={button.title}
                inverted={true}
                outlined={true}
                textColor={button.selected ? 'oxfordBlue' : 'battleShipGray'}
                backgroundColor={
                  button.selected ? 'oxfordBlue' : 'platinumDark'
                }
                onClick={() => handleSimulateButtonClick(index, button.count)}
                rounded={true}
              />
            );
          })}
      </SimulateButtonWrapper>
    </>
  );
}
